import { createContext, useState } from "react";

const AuthContext = createContext({});

export const AuthProvider = ({ children }) => {
  const [estatesArr, setEstatesArr] = useState([]);
  const [filterMenu, setFilterMenu] = useState(["All", "Sell", "Rent"]);

  const [data, setData] = useState({
    location: "",
    bedrooms: "",
    minPrice: "",
    maxPrice: "",
  });
  const [propType, setPropType] = useState("All");
  const [propUse, setPropUse] = useState("All");

  const [activeProp, setActiveProp] = useState("All");

  return (
    <AuthContext.Provider
      value={{
        estatesArr,
        setEstatesArr,
        filterMenu,
        setFilterMenu,
        data,
        setData,
        propType,
        setPropType,
        propUse,
        setPropUse,
        activeProp,
        setActiveProp,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
